import { getChatbotActionButtons } from './getChatbotActionButtons';
import { startPollingMessages } from './startPollingMessages';
import { trackApplyChatbotFilters } from './tracking';
import { closeChatbotFiltersModal, setFiltersLoading } from '../../actions/chatbotFiltersModal';
import { EActionType, EPayload } from '../../repositories/cian-chat-bot/entities/action_buttons/ActionButtonSchema';
import { fetchSavePollAnswers, TSavePollAnswersResponse } from '../../repositories/cian-chat-bot/v1/save-poll-answers';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

export const applyChatbotFilters =
  (jsonQuery: object): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger, config }) => {
    dispatch(setFiltersLoading(true));

    try {
      const { statusCode, response }: TSavePollAnswersResponse = await fetchSavePollAnswers({
        httpApi,
        parameters: { jsonQuery },
        config: { requestConfig: { withCredentials: true } },
      });

      dispatch(setFiltersLoading(false));

      /* istanbul ignore next */
      if (statusCode !== 200) {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось применить фильтры помогатора',
          domain: 'src/shared/actions/chatbotFiltersModal/applyChatbotFilters.ts [applyChatbotFilters]',
          statusCode,
          messsage: response.message || 'Неизвестная ошибка',
          errors: JSON.stringify(response?.errors),
        });

        dispatch(showAlert({ message: response.message || 'Возникла ошибка при попытке применить фильтры' }));

        return;
      }

      trackApplyChatbotFilters(jsonQuery);

      dispatch(startPollingMessages());

      const isChatbotGPTEnabled = config.get<boolean>('frontend-chats.chatbotGPT.Enabled') || false;

      /* istanbul ignore next */
      if (isChatbotGPTEnabled) {
        const {
          chatbot: { actionButtons },
        } = getState();

        const { payload, inputText } = actionButtons.find(
          ({ actionType, link }) => actionType === EActionType.Deeplink && link?.includes('chat-bot-profiling'),
        ) || { payload: EPayload.Initial };
        dispatch(getChatbotActionButtons(payload, inputText));
      }

      dispatch(closeChatbotFiltersModal());
    } catch (error) {
      /* istanbul ignore next */
      logger.error(error, {
        domain: 'src/shared/actions/chatbotFiltersModal/applyChatbotFilters.ts [applyChatbotFilters]',
        description: 'Ошибка при попытке применить фильтры помогатора',
      });

      /* istanbul ignore next */
      dispatch(setFiltersLoading(false));
      /* istanbul ignore next */
      dispatch(showAlert({}));
    }
  };
